import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { InstacartManagedReportsListPageAccessControl } from './pages/instacart-managed-reports-list/InstacartManagedReportsListPage.configuration'
import { TransactionLogsListPageAccessControl } from './pages/transaction-logs-list/TransactionLogsListPage.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'reports',
  routes,
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'reports-dashboard-tool',
  },
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {},
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.Reports,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View Instacart managed reports and analytics',
          labelId: 'reportsDomain.instacartManagedReportsList.nav',
          labelIdV3: 'reportsDomain.instacartManagedReportsList.nav.v3',
          route: 'instacart-managed-reports-list',
          accessControl: InstacartManagedReportsListPageAccessControl,
          position: 2,
          positionNavV3: 0,
          inToolPermissions: [
            {
              slug: Permission.NormalizedReportsRetailerTaxLogs,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.NormalizedReportsRetailerTaxLogs,
            },
            {
              slug: Permission.NormalizedReportsTaxesPaidAtPos,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.NormalizedReportsTaxesPaidAtPos,
            },
            {
              slug: Permission.NormalizedReportsAdsReport,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.NormalizedReportsAdsReport,
            },
          ],
        },
        {
          type: 'item',
          llmDescription:
            'View transaction logs, payment activity, and financial reconciliation records for auditing',
          labelId: 'reportsDomain.transactionLogsList.nav',
          route: 'transaction-logs-list',
          accessControl: TransactionLogsListPageAccessControl,
          position: 4,
          positionNavV3: 2,
          dividerBefore: true,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
